//! PEOPLE REDUCER
export const GET_PEOPLE = "GET_PEOPLE";
export const FILTER_PEOPLE = "FILTER_PEOPLE";
export const CLEAR_PEOPLE = "CLEAR_PEOPLE";
export const CLEAR_FILTERED = "CLEAR_FILTERED";

export const REQUEST_COMPARE_PENDING = "REQUEST_COMPARE_PENDING";
export const REQUEST_COMPARE_SUCCESS = "REQUEST_COMPARE_SUCCESS";
export const REQUEST_COMPARE_FAILED = "REQUEST_COMPARE_FAILED";

//! ATTENDEE PAGE REDUCER
export const GET_ATTENDEE_PAGE_DATA = "GET_ATTENDEE_PAGE_DATA";
export const CLEAR_ATTENDEE_PAGE_DATA = "CLEAR_ATTENDEE_PAGE_DATA";

export const REQUEST_TRANSCRIPT_PENDING = "REQUEST_TRANSCRIPT_PENDING";
export const REQUEST_TRANSCRIPT_SUCCESS = "REQUEST_TRANSCRIPT_SUCCESS";
export const REQUEST_TRANSCRIPT_FAILED = "REQUEST_TRANSCRIPT_FAILED";

export const SET_ATTENDEE_PAGE_EVENT_TYPE = "SET_ATTENDEE_PAGE_EVENT_TYPE";

//! EVENTS REDUCER
export const GET_EVENTS = "GET_EVENTS";
export const CLEAR_EVENTS = "CLEAR_EVENTS";

//! EVENT REDUCER
export const GET_EVENT_PAGE_DATA = "GET_EVENT_PAGE_DATA";
export const CLEAR_EVENT_PAGE_DATA = "CLEAR_EVENT_PAGE_DATA";
export const SET_EVENT_PAGE_EVENT_TYPE = "SET_EVENT_PAGE_EVENT_TYPE";

//! USER & AUTHENTICATION/AUTHORIZATION REDUCER
export const LOGIN_USER = "LOGIN_USER";
export const LOGOUT_USER = "LOGOUT_USER";
export const STORE_SEARCH = "STORE_SEARCH";
export const CLEAR_STORE_SEARCH = "CLEAR_STORE_SEARCH";

export const REQUEST_ADD_INDIVIDUAL_PENDING = "REQUEST_ADD_INDIVIDUAL_PENDING";
export const REQUEST_ADD_INDIVIDUAL_SUCCESS = "REQUEST_ADD_INDIVIDUAL_SUCCESS";
export const REQUEST_ADD_INDIVIDUAL_CLEAR = "REQUEST_ADD_INDIVIDUAL_CLEAR";

//! ADD REQUESTS STUFF
